"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactRouterDom = require("react-router-dom");
var _components = require("@sart/components");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _content = require("@sart/content");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HoverableDropdownMenu(props) {
  var content = (0, _content.useContent)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var options = props.options,
    label = props.label,
    labelStyle = props.labelStyle,
    containerStyle = props.containerStyle,
    dropdownMenuContainerStyle = props.dropdownMenuContainerStyle,
    menuItemStyle = props.menuItemStyle,
    hoverStyle = props.hoverStyle,
    menuTextStyle = props.menuTextStyle,
    chevronColor = props.chevronColor,
    history = props.history;
  function handleRouting(option) {
    if (option.path) {
      return history.push(option.path);
    } else if (option.url) {
      window.open(option.url);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: styles.container && containerStyle
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.label && labelStyle
  }, label), /*#__PURE__*/_react["default"].createElement(_components.Space, {
    width: 8
  }), /*#__PURE__*/_react["default"].createElement(_icons.ChevronDown, {
    width: 24,
    height: 20,
    color: chevronColor
  })), hover && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.dropdownMenuContainerStyle && dropdownMenuContainerStyle
  }, options && options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_components.HoverableView, {
      style: styles.menuItemStyle && menuItemStyle,
      onHover: styles.hover && hoverStyle,
      onPress: function onPress() {
        return handleRouting(option);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
      style: styles.menuTextStyle && menuTextStyle
    }, option.label));
  })));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    paddingTop: 6,
    zIndex: 999
  },
  label: _objectSpread({
    fontSize: 13,
    fontWeight: '700',
    color: _styles.colors.black
  }, _styles.typography.bold),
  dropdownMenuContainerStyle: _objectSpread(_objectSpread({}, _styles.typography.medium), {}, {
    backgroundColor: _styles.colors.white,
    borderRadius: 8,
    color: _styles.colors.white,
    position: 'absolute',
    top: 24
  }),
  menuItemStyle: {
    height: 35,
    width: 110,
    justifyContent: 'center',
    backgroundColor: _styles.colors.white,
    borderRadius: 8
  },
  hover: {
    height: 35,
    width: 110,
    justifyContent: 'center',
    backgroundColor: _styles.colors.black + 40,
    borderRadius: 8
  },
  menuTextStyle: _objectSpread(_objectSpread({
    fontSize: 13,
    fontWeight: '700',
    color: _styles.colors.white
  }, _styles.typography.bold), {}, {
    textAlign: 'center'
  })
});
var _default = exports["default"] = (0, _reactRouterDom.withRouter)(HoverableDropdownMenu);